
// React
import React from 'react';

// Components
import ModalComponent from 'shared/components/modal/ModalComponent';

// Styles
import './CompleteEmailPhoneModalComponent.styles.css';

//i18
import { withTranslation } from 'react-i18next';
import PrimaryButtonComponent from 'shared/components/primary-button/PrimaryButtonComponent';
import TextButtonComponent from 'shared/components/text-button/TextButtonComponent';

function CompleteEmailPhoneModalComponent( props ) {

    return (
        <ModalComponent 
            isOpen={props.isOpen}
            //onClose={props.onClose}
            className={'complete-email-phone-modal'}
        >
            <div className='complete-email-phone-modal__container'>
                <div className='baloa-subtitle-2'>{props.t(`completeEmailPhoneModal.${props.field_type}.title`)}</div>
                <div className="baloa-names">{props.t(`completeEmailPhoneModal.${props.field_type}.message`)}</div>
                <PrimaryButtonComponent
                    input_type={'button'}
                    onClick={ ()=>{ props.handleOnAddFieldData(props.field_type) }}
                >
                    <span>{props.t(`completeEmailPhoneModal.${props.field_type}.addBtnLbl`)}</span>
                </PrimaryButtonComponent>
                <TextButtonComponent
                    input_type={'button'}
                    onClick={ ()=>{ props.handleOnCloseSession() }}
                >
                    <span>{props.t(`completeEmailPhoneModal.closeBtnLbl`)}</span>
                </TextButtonComponent>
            </div>            
        </ModalComponent>
    )
}
    
export default withTranslation('signUp')(CompleteEmailPhoneModalComponent);